module.exports = __webpack_public_path__ + "static/media/github.567f006b.svg";